import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {CategoryState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class CategoryQuery extends QueryEntity<CategoryState> {

  constructor(protected store: Store) {
    super(store);
  }

}
